export enum SortDirection {
    Ascending,
    Descending
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/enums/sort-direction.ts